<template>
  <Card>
    <AjaxForm v-if="admin" :route="'admin/Manager/Edit/'+admin._id">
      <div class="row">
        <div class="col-12 col-md-4">
          <CustomInput type="text" v-model="admin.fullname" input_style="twoLine" name="fullname" label="نام کامل"></CustomInput>
        </div>
        <div class="col-12 col-md-4">
          <CustomInput type="text" v-model="admin.phone" input_style="twoLine" name="phone" label="تلفن تماس"></CustomInput>
        </div>
        <div class="col-12 col-md-4">
          <CustomInput type="text" v-model="admin.email" input_style="twoLine" name="email" label="ایمیل"></CustomInput>
        </div>
        <div class="col-12 col-md-4">
          <CustomInput type="text" v-model="admin.username" input_style="twoLine" name="username" label="نام کاربری"></CustomInput>
        </div>
        <div class="col-12 col-md-4">
          <CustomInput type="select" input_style="twoLine"
                       :select-options="roleOptions" select-label="title"
                       v-model="selected_role"
                       placeholder="نقش کاربری را انتخاب کنید" name="role" reduce_select="value" label="نقش کاربری"></CustomInput>
        </div>
      </div>
      <div class="row">
        <div class="col-10 col-md-5 mx-auto my-3">
          <button class="btn btn-info btn-block" type="submit">ثبت تغییرات</button>
        </div>
      </div>
    </AjaxForm>
    <div v-if="error" class="alert alert-danger">
      {{error}}
    </div>
  </Card>
</template>

<script>
import Card from "@/components/forms/Card";
import {mapActions} from "vuex";
import AjaxForm from "@/components/forms/AjaxForm";
import CustomInput from "@/components/CustomInput";
import {AppApi} from "@/api/AppApi";
import {findSelectItem, getAdminRoles} from "@/shared/helper";
export default {
name: "ManagerEdit",
  components: {CustomInput, AjaxForm, Card},
  data()
  {
    return{
      admin : null,
      error : null,
      id : this.$route.params.id,
      roleOptions : getAdminRoles(),
      selected_role : null,
    }
  },
  mounted()
  {
    this.setPageLoading(false);
    this.setPageTitle('ویرایش اطلاعات مدیر');
    this.setShowHead(true);
    this.initPage();
  },
  methods :{
    ...mapActions('app', {
      setPageTitle: 'setPageTitle',
      setPageLoading: 'setPageLoading',
      setShowHead: 'setShowHead'
    }),
    async initPage()
    {
      this.setPageLoading(true);
      this.id = this.$route.params.id;
      this.error = null;
      this.admin = null;
      const result = await AppApi.getManagerForEdit(this.id);
      if (result.ok)
      {
        this.admin = result.manager;
        this.selected_role = findSelectItem(this.admin.user_role,this.roleOptions,'value')
      }
      else
        this.error = null;
      this.setPageLoading(false);
    }
  }
}
</script>

<style scoped>

</style>